import { h400 } from 'view/styles/fonts';
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';

export const Container = styled.div`
    text-align: left;
`;

export const ButtonContainer = styled.div`
    margin-top: ${token('space.300', '24px')};
`;

export const InfoSectionContainer = styled.div`
    margin-top: ${token('space.300', '24px')};
    border-top: 1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')};
`;

export const InfoSectionTitle = styled.div`
    ${h400}
    margin-top: ${token('space.300', '24px')};
`;

export const InfoSectionContent = styled.div`
    margin-top: ${token('space.050', '4px')};
`;
